import service from '../utils/request'
import { AxiosPromise } from 'axios'

/** 头部参数
 * @param tenantId 租户id
 * @param username 用户名
 * @param password 密码
 * @param grantType 授权类型：密码|刷新token|手机号
 * @param refresh_token 刷新token
 */
export const loginByUsername = (
  tenantId: any,
  username: any | null,
  password: any | null,
  grantType?: string,
  refresh_token?: string,
  code?: string,
  mobile?: string
) => {
  let params = {}
  if (grantType && grantType === 'refresh_token') {
    params = {
      grant_type: 'refresh_token',
      refresh_token,
    }
  } else if (grantType && grantType === 'mobile') {
    params = {
      grant_type: 'mobile',
      mobile,
      scope: 'all',
      code,
    }
  } else {
    params = {
      tenantId,
      username,
      password,
      grant_type: 'password',
      scope: 'all',
      type: 'account',
    }
  }
  return service.post(`/blade-auth/oauth/token`, params, {
    headers: {
      'Tenant-Id': tenantId,
    },
  })
}

/** 上传文件（头像）
 * */
export const putFilePOST = (file: any) => uploadFile(file)

export const putFile = (file: any,onresolve: any, onreject: any) =>
      uploadFile(file)
        .then((res: any) => {
          if (res) {onresolve(res)}
        }, onreject)

/**
 *
 * @param file 语言包
 */
export const putLangFile = (file: any) =>
  service.post(`/masterlink-language/language-text/import`, file, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

/**
 * @param language 语言
 * @param tenantId 租户id
 */
export const findAllLangs = (tenantId: any, language: string) =>
  service.get(`/masterlink-language/language-text/findall?language=${language}`, {
    headers: {
      'Tenant-Id': tenantId,
    },
  })

/**
 * 单个文件上传
 * @param file (optional) file
 * @return OK
 */
export const uploadPOST = (file: any) => uploadFile(file)

const uploadFile = (file: any) => service.post(`/blade-resource/oss/endpoint/put-file`, file)


/**
 * 单个文件上传到服务
 * @param file (optional) file
 * @return OK
 */
 export const postFileAttach = (file: any) => uploadFileAttach(file)

 const uploadFileAttach = (file: any) => service.post(`/blade-resource/oss/endpoint/put-file-attach`, file)


/**
 * 单个文件下载
 * @param fileName fileName
 * @param objectKey objectKey
 * @return OK
 */
export const downloadGET = (fileName: string, objectKey: string, contentType?: string) =>
  service.get(`/blade-resource/oss/endpoint/file-content?fileName=${objectKey}`, {
    responseType: 'blob',
  })


/**
 * iot下载
 * @param fileName fileName
 * @param objectKey objectKey
 * @return OK
 */
export const iotExport = (data: any) =>
  service.post('/masterlink-cps-work-station/work-stations/gateway-export',
    data,
    {
    responseType: 'blob',
    }
)


// export const downloadTest = (fileName: string, objectKey: string, contentType: string) =>
//   service.get(`/app-dnc/obsFile/download-file?fileName=${objectKey}&objectKey=${objectKey}&contentType=${contentType}`, {
//     responseType: 'blob',
//   })

/**
 * 导出产品模板
 * @return OK
 */
export const exportProductTemplateGET = (typeId: string) =>
  service.get(`/masterlink-cps-product/product/export/template?typeId=${typeId}`, { responseType: 'blob' })

/**
 * 导出产品工序模板
 * @param {string} typeId 产品类型
 * @return OK
 */
export const exportProcessTemplateGET = (typeId: string) =>
  service.get(`/masterlink-cps-product/product-craft/import/download-temple?typeId=${typeId}`, { responseType: 'blob' })

/**
 * 导出产品工艺流程
 * @return OK
 */
export const exportProductCraftGET = (craftId: string) =>
  service.get(`/masterlink-cps-product/product-craft/export/${craftId}`, { responseType: 'blob' })

/**
 * 导出产品
 * @return OK
 */
export const exportProductPOST = (data: any) =>
  service.post(`/masterlink-cps-product/product/export`, data, { responseType: 'blob' })

/**
 * 导入产品数据, 特别定制：延长错误提示时间为5秒
 * @param data file
 * @return OK
 */
export const importProductsPOST = (data: any) => service.post(`/masterlink-cps-product/product/importProAndCraft`, data, { duration: 5 } as any)

/**
 * 批量导入产品工艺工序
 * @param data (optional) any
 * @return OK
 */
export const importProductpProcess = (data: any) =>
  service.post(`/masterlink-cps-product/product-craft/import/import-excel`, data)

// 导出生产计划模板
export const exportProductionPlanTemplate = (bizDataId: string): AxiosPromise<BlobPart> =>
  service({
    method: 'GET',
    url: '/app-coproduction/production-plan-excel/export/production-plan/template?bizDataId=' + bizDataId,
    responseType: 'blob',
  })

// 导出来料计划模板
export const exportIncomingPlanTemplate = (bizDataId: string): AxiosPromise<BlobPart> =>
  service({
    method: 'GET',
    url: '/app-coproduction/production-plan-excel/export/incoming-plan/template?bizDataId=' + bizDataId,
    responseType: 'blob',
  })

// 导出生产计划
export const exportProductionPlan = (data): AxiosPromise<BlobPart> =>
  service({
    method: 'POST',
    data,
    url: '/app-coproduction/production-plan-excel/export',
    responseType: 'blob',
  })

// 导出工单
export const exportWorkOrder = (planId, params): AxiosPromise<BlobPart> =>
  service({
    method: 'POST',
    params,
    url: `/app-coproduction/export-production-order/${planId}/export-list`,
    responseType: 'blob',
  })

// 生产工序导出
export const exportProductionOrder = () =>
  service.post('/masterlink-cps-work-station/process/excel/export', null, { responseType: 'blob' })

// 生产工序导入
export const importProductionOrder = data => service.post('/masterlink-cps-work-station/process/excel/import', data, { responseType: 'blob' })

// 生产工序模板
export const downloadProductionOrderTemplate = () =>
  service.get('/masterlink-cps-work-station/process/excel/export/template', { responseType: 'blob' })

// 员工导出
export const exportEmployee = (data) =>
  service.get('/masterlink-cps-employee/employee-excel/export', { responseType: 'blob' })

// 员工导入
export const importEmployee = data =>
 service({
    url: '/masterlink-cps-employee/employee-excel/import',
    method: 'PUT',
    data,
    headers: {
    'Content-Type': 'multipart/form-data',
    },
    responseType: 'blob',
  })

// 员工模板
export const downloadEmployeeTemplate = () =>
  service.get('/masterlink-cps-employee/employee-excel/export/template', { responseType: 'blob' })

// 计划进度
export const exportPlan = (data, params) =>
  service({
    url: '/app-coproduction/production-statistics-excel/export-plan-schedule',
    method: 'POST',
    data,
    params,
    responseType: 'blob',
  })

// 超期分析
export const exportOverdue = (data, params) =>
  service({
    url: '/app-coproduction/production-statistics-excel/export-plan-overdue',
    method: 'POST',
    data,
    params,
    responseType: 'blob',
  })

// 在制品分析
export const exportProduction = (data, params) =>
  service({
    url: '/app-coproduction/production-statistics-excel/plan-wip/page',
    method: 'POST',
    data,
    params,
    responseType: 'blob',
  })

// 人员业绩分析
export const exportPerformance = (data, params) =>
  service({
    url: '/app-coproduction/production-statistics-excel/export-plan-employee-performance',
    method: 'POST',
    data,
    params,
    responseType: 'blob',
  })

// 生产综合统计
export const exportStatisticsReport = (data, params) =>
  service({
    url: '/app-coproduction/production-statistics-excel/export_production-statistic-report',
    method: 'POST',
    data,
    params,
    responseType: 'blob',
  })

// 导出生产综合统计-工位查询
export const exportWorkStationReport = (data, params) =>
  service({
    url: '/app-coproduction/production-statistics-excel/export-production-statistic-by-work-station-report',
    method: 'POST',
    data,
    params,
    responseType: 'blob',
  })

// 工序分析
export const exportProcess = (data, params) =>
  service({
    url: '/app-coproduction/production-statistics-excel/export-plan-process-schedule',
    method: 'POST',
    data,
    params,
    responseType: 'blob',
  })

// 工序分析
export const exportGateway = params =>
  service({
    url: `/masterlink-cps-work-station/iothub-properties/gateway-app/export`,
    method: 'GET',
    params,
    responseType: 'arraybuffer',
  })

/**
 * 导入物模型数据
 *  @param file (optional) file
 * @return OK
 */
export const importPropertiesByFile = (data: any) =>
  service.post(`masterlink-cps-work-station/iothub-properties/gateway-app/import-file`, data)

//导出dmp
export const exportDmp = id =>
  service({
    url: `/masterlink-cps-work-station/dmp/export/${id}`,
    method: 'get',
    responseType: 'blob',
  })

//导出工况参数
export const exportWorkParams = id =>
  service({
    url: '/masterlink-cps-work-station/working-condition-params/export-json',
    method: 'POST',
    params: {
      workStationId: id,
    },
    responseType: 'blob',
  })

//导入工况参数
export const importWorkParams = data =>
  service({
    url: '/masterlink-cps-work-station/working-condition-params/import-json',
    method: 'POST',
    data,
    // responseType: 'blob',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

// 导出加工过程参数
export const exportParameters = data =>
  service({
    url: '/app-mdc/process-parameters-excel/export-process-parameters',
    method: 'POST',
    data,
    responseType: 'blob',
  })

// 导出状态记录
export const exportStatusRecord = data =>
  service({
    url: '/app-mdc/mdc/status-record/export',
    method: 'POST',
    data,
    responseType: 'blob',
  })
// 导出工位状态比率
export const exportAnalysis = data =>
  service({
    url: '/app-mdc/process-parameters-excel/export-time-analysis-wcs',
    method: 'POST',
    data,
    responseType: 'blob',
  })
// 导出产量报表
export const exportOutput = data =>
  service({
    url: '/app-mdc/mdc/excel/export-output',
    method: 'POST',
    data,
    responseType: 'blob',
  })
// 工位参数统计导出能耗数据
export const exportEnergy = data =>
  service({
    url: '/app-mdc/mdc/excel/export-electricity',
    method: 'POST',
    data,
    responseType: 'blob',
  })
  // 导出产量报表
export const exportWorkstationLogin = data =>
  service({
    url: '/app-mdc/workstation-statistics/export-workstation-login',
    method: 'POST',
    data,
    responseType: 'blob',
  })
// 导出综合效率报表
export const exportRps = data =>
  service({
    url: '/app-mdc/mdc/excel/export-rps',
    method: 'POST',
    data,
    responseType: 'blob',
  })
// 导出报警报表
export const exportAlarm = data =>
  service({
    url: '/app-mdc/mdc/excel/export-alarm',
    method: 'POST',
    data,
    responseType: 'blob',
  })
// 导出移库记录
export const exportShift = areaId =>
  service({
    url: '/app-wms/stock-shift-record/excels/export',
    method: 'POST',
    params: {
      areaId: areaId,
    },
    responseType: 'blob',
  })
// 导出出入库记录
export const exportInOut = (areaId, locationId, materialId) =>
  service({
    url: '/app-wms/stock-in-out-record/excels/export',
    method: 'POST',
    params: {
      areaId: areaId,
      locationId: locationId,
      materialId: materialId,
    },
    responseType: 'blob',
  })

//导出物料数据
export const exportCheck = (areaId,keyWord) =>
  service({
    url: '/masterlink-cps-warehouse/warehouse_material_inventory/export',
    method: 'POST',
    params: {
      areaId: areaId,
      keyWord: keyWord,
    },
    responseType: 'blob',
  })

//导入物料数据
export const importCheck = data =>
  service({
    url: '/masterlink-cps-warehouse/warehouse_material_inventory/import',
    method: 'POST',
    data,
  })

//导入盘点数据
export const importCheckDynamic = data =>
  service({
    url: '/masterlink-cps-warehouse/warehouse_material_inventory/import-test-dynamic',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    responseType: 'blob',
  })

//下载物料模板
export const exportMaterialTemplate = () =>
  service({
    url: '/masterlink-cps-material/material/export/template',
    method: 'get',
    responseType: 'blob',
  })

  //下载库区库位模版
export const exportLocationTemplate = (val) =>
service({
  url: '/masterlink-cps-warehouse/warehouse-areas/export/template',
  method: 'POST',
  data: {
    areaId: val
  },
  responseType: 'blob',
})

//导入物料
export const importMaterial = data =>
  service({
    url: '/masterlink-cps-material/material/import-verification',
    method: 'POST',
    data,
    responseType: 'blob',
  })

//导出物料
export const exportMaterial = data =>
  service({
    url: '/masterlink-cps-material/material/export',
    method: 'POST',
    data,
    responseType: 'blob',
  })

  //导入库区库位
export const importLocation = (data,params) =>
service({
  url: '/masterlink-cps-warehouse/warehouse-areas/import',
  method: 'POST',
  data,
  params,
  responseType: 'blob',
})

//导出库区库位
export const exportLocation = (val) =>
  service({
    url: '/masterlink-cps-warehouse/warehouse-areas/export',
    method: 'POST',
    data: {
      areaId: val
    },
    responseType: 'blob',
  })

export const exportCheckItem = data =>
  service({
    url: `/app-tpm/check-record-excel/export`,
    method: 'POST',
    data,
    responseType: 'blob',
  })

// 导出点检项目模板
export const exportCheckProjectTemplate = () =>
  service({
    url: `/app-tpm/check-projects/excel/export/template`,
    method: 'GET',
    responseType: 'blob',
  })

// 导出点检项目
export const exportCheckProjectAndItem = id =>
  service({
    url: `/app-tpm/check-projects/excel/export`,
    method: 'POST',
    data: { id },
    responseType: 'blob',
  })

// 导入点检项目
export const importProducts = data =>
  service({
    url: `/app-tpm/check-projects/excel/import`,
    method: 'POST',
    data,
    responseType: 'blob',
  })

// 导入保养项
export const importMaintainItem = data =>
  service({
    url: `/app-tpm/maintain-item/import-maintain-item`,
    method: 'POST',
    data,
    responseType: 'blob',
  })

// 导出保养项模板
export const exportMaintainItemTemplate = data =>
  service({
    url: `/app-tpm/maintain-item/export/template`,
    method: 'GET',
    data,
    responseType: 'blob',
  })

// 导出保养项
export const exportMaintainItem = data =>
  service({
    url: `/app-tpm/maintain-item/export`,
    method: 'POST',
    data,
    responseType: 'blob',
  })

// 导出保养记录

export const exportMaintainRecord = data =>
  service({
    url: `/app-tpm/maintain-record/export`,
    method: 'POST',
    data,
    responseType: 'blob',
  })

// 导出保养记计划
export const exportMaintainPlan = data =>
  service({
    url: `/app-tpm/maintain-plan/export`,
    method: 'POST',
    data,
    responseType: 'blob',
  })

//导出设备信息
export const exportDevice = data =>
  service({
    url: `/masterlink-cps-work-station/device/excel/export`,
    method: 'POST',
    data,
    responseType: 'blob',
  })
//导出维修记录
export const exportRecord = data =>
  service({
    url: `/app-tpm/repair-record/export-record`,
    method: 'POST',
    data,
    responseType: 'blob',
  })
  //导出备品工况
  export const exportDeviceMaterial = data =>
  service({
    url: `/app-tpm/device-material-records/excel/export`,
    method: 'POST',
    data,
    responseType: 'blob',
  })

// 导出故障类型模板
export const exportMalfunctionTypeTemplate = () =>
  service.get(`/app-tpm/malfunction-type/export/malfunction_template`, { responseType: 'blob' })

// 导入故障类型
export const importMalfunctionType = (data) =>
  service.post(`/app-tpm/malfunction-type/import-malfunction`, data,{ responseType: 'blob' })

// 导出故障类型
export const exportMalfunctionType = (data) =>
  service.post(`/app-tpm/malfunction-type/export-malfunction`, data,{ responseType: 'blob' })

// 设备类型模板导出
export const exportDeviceTypeTemplate = () =>
  service.get(`/masterlink-cps-work-station/device-types/excel/export/template`, { responseType: 'blob' })

// 导入设备类型
export const importDeviceType = (data) =>
  service.post(`/masterlink-cps-work-station/device-types/excel/import`, data,{ responseType: 'blob' })

// 导出设备类型
export const exportDeviceType = (data) =>
  service.post(`/masterlink-cps-work-station/device-types/excel/export`, data,{ responseType: 'blob' })

// 导出维修记录
// export const exportRecord = (data) =>
//   service.post(`/app-tpm/repair-record/export-record`, data,{ responseType: 'blob' })

// 导出维修申请
export const exportRepairApply = (data) =>
  service.post(`/app-tpm/repair-apply/export-apply`, data,{ responseType: 'blob' })

// 导出工位生产日历报表
export const getPageWorkStationCalendarReport = (params, data) => {
  return service({
    url: '/app-coproduction/production-statistics-excel/export_workStation-calendar-report',
    method: 'POST',
    data,
    params,
    responseType: 'blob',
  })
  // return service.post(`/app-coproduction/production-statistics-excel/export_workStation-calendar-report?bizCode=${bizCode}&bizDataId=${bizDataId}&current=${current}&size=${size}&tenantId=${tenantId}`, data, { responseType: 'blob' })
}

// 导出客户
export const exportCustomer = (data) =>
service.post(`/masterlink-cps-client/customers/export`, data,{ responseType: 'blob' })

// 导出报工记录（报工历史）
export const exportProcessHistory = (orderId: string, dizType: string) =>
  service.get(`/app-coproduction/order-record/export-record-list/${orderId}?bizType=${dizType}`, { responseType: 'blob' })

//导出工作记录
export const exportWorkRecord = data =>
  service({
    url: '/masterlink-cps-work-record/work-record/export',
    method: 'POST',
    data,
    responseType: 'blob',
  })

//导出工作记录
export const exportRecordReport = data =>
    service({
        url: '/masterlink-cps-work-record/work-record/report/export-report',
        method: 'POST',
        data,
        responseType: 'blob',
    })

export const editionDetail = () =>
  service.get('/blade-system/publish-record/user/detail')

export const queryRole = (tenantId) =>
  service.get(`/blade-system/tenants/detail/${tenantId}`)

export const editionHistory = () =>
  service.get('/blade-system/publish-record/history')

// 导入专家库
export const importKnowledgeLibrary = data =>
  service({
    url: `/masterlink-cps-knowledge-library/knowledge-library/import`,
    method: 'POST',
    data,
    responseType: 'blob',
  })

// 导出稼动率
export const exportUtilizationRate = data =>
  service({
    url: `/app-mdc/mdc/export`,
    method: 'POST',
    data,
    responseType: 'blob',
  })
// 导出报警历史
export const exportAlarmHistory = (data) =>
service.post(`/app-mdc/alarm-history/export`, data,{ responseType: 'blob' })

// 安灯类型模板
  export const exportAndonTypeTpl = () =>
  service.get(`/app-andon/andon-type/export/template`, { responseType: 'blob' })

// 安灯导入类型
  export const importAndonType = (data) =>
  service.post(`/app-andon/andon-type/import`, data,{ responseType: 'blob' })

// 安灯类型导出
 export const exportAndonType = () =>
  service.get(`/app-andon/andon-type/export`, { responseType: 'blob' })

  // 安灯确认记录导出
 export const andonCallRecordConfirmExport = (data) =>
 service.post(`/app-andon/andon-call-record-confirm-excel/excel`,data,{ responseType: 'blob' })

 // 安灯频次统计导出
 export const andonStatisticsExcelExport = (data) =>
 service.post(`/app-andon/andon-statistics-excel/frequency`,data,{ responseType: 'blob' })

// 导出报废原因分析报表
 export const scrappedReasonExport = (data, params) =>
 service.post(`/app-coproduction/production-statistics-excel/export-scrapped-reason-report?current=${params.current}&size=${params.size}`,data,{ responseType: 'blob' })

// 登录日志导出
export const loginLogExport = (data) =>
  service.post(`/blade-user/user-login/export`,data,{ responseType: 'blob' })

// 通知
export const notifierTemplate = ({type, provider}) => {
    return service({
        url: `/masterlink-notify/notifier/template/${provider}/${type}/config/metadata`,
        method: 'GET',
    })
}

// 导入客户
export const importCustomer = (data) =>
    service.post(`/masterlink-cps-client/customers/import`, data,{ responseType: 'blob' })

// 导入客户
export const exportCustomerTemplate = (data) =>
    service.get(`/masterlink-cps-client/customers/export-template`,{ responseType: 'blob' })

// 导入自定义设备
export const importCustomDevice = (data) =>
    service.post(`/masterlink-cps-work-station/custom-machine/import`, data, { responseType: 'blob' })

// 导出自定义设备模板
export const exportCustomDeviceTemplate = (data) =>
    service.get(`/masterlink-cps-work-station/custom-machine/export-template`,{ responseType: 'blob' })

// 导出员工统计
export const exportCustomerStatistic = (data) =>
    service.post(`/masterlink-cps-work-record/work-record/statistics/handler-export`, data, { responseType: 'blob' })